import { ValueProps } from "@/types/ValueProp";
import Image from "next/image";
import parse from "html-react-parser";

export default function WeddingValueProps({
  valueProps
}: {
  valueProps: ValueProps;
}) {
  return (
    <section className="pt-4 pb-8 bg-white px-4 sm:px-8 2xl:px-0">
      <div className="container max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
          {valueProps.map((prop, index) => {

            return (
              <div
                key={index}
                className="flex flex-col items-center text-center gap-1 md:gap-4"
              >
                <Image
                  src={prop.image}
                  width={64}
                  height={64}
                  alt={prop.image_alt}
                />
                <b className="body-reg-bold">{prop.heading}</b>
                <div className="!body-reg">{parse(prop.content)}</div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  );
}
